module.exports = __webpack_public_path__ + "img/ski10.a4b6e48e.png";